import { ICianAnalytics, IPageViewData } from 'shared/map-search/types/analytics';

import { getPageViewData } from './pageViewEvent';
import { IDependencies } from './types';

export function ensurePageCa(dependencies: IDependencies) {
  const { logger } = dependencies;

  try {
    const pageviewData = getPageViewData(dependencies, window.ca.q);
    if (!pageviewData) {
      return;
    }

    let originalCa = window.ca;
    let caFunc = createCaWrapper(originalCa, pageviewData);

    Object.defineProperty(window, 'ca', {
      get() {
        return caFunc;
      },
      set(nextCa: ICianAnalytics) {
        originalCa = nextCa;
        caFunc = createCaWrapper(nextCa, pageviewData);

        return caFunc;
      },
    });
  } catch (error) {
    logger.error(error, { domain: 'browser.utils.ensurePageCa.ensurePageCa()' });
  }
}

export function createCaWrapper(ca: ICianAnalytics, pageviewData: IPageViewData): ICianAnalytics {
  let page = pageviewData.page;

  function preparePage(rawPage: IPageViewData['page']) {
    return {
      ...rawPage,
      listingType: 'map',
      extra: {
        ...rawPage.extra,
        ...page.extra,
      },
    };
  }
  // oxlint-disable-next-line typescript/no-explicit-any
  function wrapper(...args: any[]) {
    const [eventType, eventParams = {}] = args;

    if (eventType === 'pageview') {
      if (!eventParams.isIframe) {
        page = eventParams.page;

        return ca(eventType, eventParams);
      }

      delete eventParams.isIframe;
      const nextParams = { ...eventParams, page: preparePage(eventParams.page) };
      ca(eventType, nextParams);
      ca('set', { page });

      return;
    }

    if (eventParams.page) {
      eventParams.page = preparePage(eventParams.page);
    }

    return ca(eventType, eventParams);
  }

  (wrapper as ICianAnalytics).q = window.ca.q;

  return wrapper as ICianAnalytics;
}
